module.exports = __webpack_public_path__ + "static/chat2-145d35ccd50b1f3b03551bcdbc1072f3.png";